import React, { useState } from 'react';
import ElementLoading from 'components/shared/ElementLoading/ElementLoading';
import UniversalPlayer from 'components/shared/UniversalPlayer';
import ElementBase from '../base';
import SelectContent from './SelectContent';

const Content = props => {
  const {
    content: { content_id: id, library_content_id: libraryContentId },
    requestUpdateAndApplyChanges,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const renderContent = () => {
    if (id && libraryContentId) {
      return <UniversalPlayer id={id} />;
    }
    return (
      <SelectContent
        requestUpdateAndApplyChanges={requestUpdateAndApplyChanges}
        setIsLoading={setIsLoading}
      />
    );
  };
  return (
    <div className="EditorElement-content">
      <ElementLoading
        isLoading={isLoading}
        text={t('questions.types.content.loading')}
      >
        {renderContent()}
      </ElementLoading>
    </div>
  );
};

export default ElementBase(Content);
